import { required, maxLength, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a attribute name.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Attribute name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        pattern: helpers.withMessage(i18n.global.t('Name can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Za-zก-๙0-9_/&+.,'"()% -]+$/)),
      },
      // ชื่ออังกฤษ optional — ไม่กรอกก็ได้ ระบบจะ fallback ไปใช้ชื่อไทย
      name_en: {
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Attribute name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(255)
        ),
        pattern: helpers.withMessage(i18n.global.t('English name can include English letters, numbers, and certain special characters.'), helpers.regex(/^[A-Za-z0-9_/&+.,'"()% -]+$/)),
      },
      code: {
        required: helpers.withMessage(i18n.global.t('Please enter a attribute code.'), required),
        maxLength: helpers.withMessage(
          ({
            $params,
          }) => i18n.global.t('Code cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
          maxLength(50)
        ),
        pattern: helpers.withMessage(i18n.global.t('Code can include Thai, English, and numeric characters, as well as certain special characters.'), helpers.regex(/^[A-Za-zก-๙0-9_/& -]+$/)),
      },
      options: {
        required: helpers.withMessage(i18n.global.t('Please add at least one option.'), required)
      }
    }
  }
};
